import generateUtilityClass from '@mui/material/generateUtilityClass';
import generateUtilityClasses from '@mui/material/generateUtilityClasses';

interface DraggableClasses {
  /** Styles applied to the root element. */
  root?: string;
  /** Styles applied to the root element if `variant="flat"`. */
  flat?: string;
  /** Styles applied to the root element if `variant="outlined"`. */
  outlined?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="primary"`. */
  flatPrimary?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="secondary"`. */
  flatSecondary?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="success"`. */
  flatSuccess?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="error"`. */
  flatError?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="info"`. */
  flatInfo?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="warning"`. */
  flatWarning?: string;
  /** Styles applied to the root element if `variant="flat"` and `color="neutral"`. */
  flatNeutral?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
  outlinedPrimary?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
  outlinedSecondary?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="success"`. */
  outlinedSuccess?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="error"`. */
  outlinedError?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="info"`. */
  outlinedInfo?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
  outlinedWarning?: string;
  /** Styles applied to the root element if `variant="outlined"` and `color="neutral"`. */
  outlinedNeutral?: string;
  /** Styles applied to the drag icon. */
  dragIcon?: string;
}

function getDraggableUtilityClass(slot: string) {
  return generateUtilityClass('Draggable', slot);
}

const draggableClasses: DraggableClasses = generateUtilityClasses('Draggable', [
  'root',
  'flat',
  'outlined',
  'flatPrimary',
  'flatSecondary',
  'flatSuccess',
  'flatError',
  'flatInfo',
  'flatWarning',
  'flatNeutral',
  'outlinedPrimary',
  'outlinedSecondary',
  'outlinedSuccess',
  'outlinedError',
  'outlinedInfo',
  'outlinedWarning',
  'outlinedNeutral',
  'dragIcon',
]);

type DraggableClassKey = keyof DraggableClasses;
export type { DraggableClasses, DraggableClassKey };
export { draggableClasses, getDraggableUtilityClass };
